<div class="lg:grid lg:grid-cols-[minmax(0,1fr)_440px] lg:items-start lg:gap-12 xl:gap-20">
  <!-- Left column: summary -->
  <div class="max-w-xl">
    <h1 class="text-4xl font-extrabold tracking-tight text-gray-900">One last look.</h1>
    <p class="mt-3 text-lg text-gray-600">Anything here can be changed later in your portal.</p>

    <div class="mt-8 divide-y divide-gray-200 rounded-xl border border-gray-300">
      <div class="flex items-start justify-between gap-4 p-5">
        <div>
          <p class="field-label mb-1">Email Address</p>
          <p class="text-gray-900">{{ email || 'Not provided' }}</p>
        </div>
        <button type="button" (click)="navigateToEdit('email')"
          class="text-sm font-semibold text-red-700 hover:text-red-800 hover:underline">Edit</button>
      </div>

      <div class="flex items-start justify-between gap-4 p-5">
        <div>
          <p class="field-label mb-1">Business Name</p>
          <p class="text-gray-900">{{ businessName || 'Not provided' }}</p>
        </div>
        <button type="button" (click)="navigateToEdit('businessName')"
          class="text-sm font-semibold text-red-700 hover:text-red-800 hover:underline">Edit</button>
      </div>

      <div class="flex items-start justify-between gap-4 p-5">
        <div>
          <p class="field-label mb-1">Contact Person</p>
          <p class="text-gray-900">{{ contactLine }}</p>
        </div>
        <button type="button" (click)="navigateToEdit('contact')"
          class="text-sm font-semibold text-red-700 hover:text-red-800 hover:underline">Edit</button>
      </div>

      <div class="flex items-start justify-between gap-4 p-5">
        <div>
          <p class="field-label mb-1">Venue Type</p>
          <p class="text-gray-900">{{ venueTypeLine }}</p>
        </div>
        <button type="button" (click)="navigateToEdit('venueType')"
          class="text-sm font-semibold text-red-700 hover:text-red-800 hover:underline">Edit</button>
      </div>

      <div class="flex items-start justify-between gap-4 p-5">
        <div>
          <p class="field-label mb-1">Business Address</p>
          <p class="text-gray-900">{{ addressLine }}</p>
        </div>
        <button type="button" (click)="navigateToEdit('address')"
          class="text-sm font-semibold text-red-700 hover:text-red-800 hover:underline">Edit</button>
      </div>

      <div class="flex items-start justify-between gap-4 p-5">
        <div>
          <p class="field-label mb-1">Plan</p>
          <p class="text-gray-900">{{ planLine }}</p>
        </div>
        <button type="button" (click)="navigateToEdit('selectedPlan')"
          class="text-sm font-semibold text-red-700 hover:text-red-800 hover:underline">Edit</button>
      </div>
    </div>

    <button
      type="button"
      class="btn-brand mt-8 w-full"
      (click)="submitVenue()"
      [disabled]="isLoading"
    >
      <span *ngIf="!isLoading">Submit my details</span>
      <span *ngIf="isLoading" class="inline-flex items-center gap-2">
        <svg class="h-5 w-5 animate-spin" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
          <path class="opacity-75" fill="currentColor"
            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
        </svg>
        Submitting...
      </span>
    </button>

    <p class="mt-3 text-sm text-gray-500">
      No card charged today. We'll email your portal invite once we've reviewed this.
    </p>
  </div>

  <!-- Right column: what happens after the invite (desktop only) -->
  <aside class="mt-12 hidden rounded-2xl border border-stone-200 bg-stone-50 p-8 lg:mt-0 lg:block">
    <h2 class="text-xs font-semibold uppercase tracking-widest text-gray-500">Next, after your invite</h2>
    <ol class="mt-5 space-y-5">
      <li class="flex gap-3">
        <span class="font-bold text-red-700">1</span>
        <div>
          <p class="font-bold text-gray-900">Set up your login</p>
          <p class="mt-0.5 text-gray-600">One click from the invite email.</p>
        </div>
      </li>
      <li class="flex gap-3">
        <span class="font-bold text-red-700">2</span>
        <div>
          <p class="font-bold text-gray-900">Build your menu</p>
          <p class="mt-0.5 text-gray-600">Start from a template for {{ menuTemplatePhrase }}.</p>
        </div>
      </li>
      <li class="flex gap-3">
        <span class="font-bold text-red-700">3</span>
        <div>
          <p class="font-bold text-gray-900">Connect your payout account</p>
          <p class="mt-0.5 text-gray-600">Needed before your first order settles.</p>
        </div>
      </li>
      <li class="flex gap-3">
        <span class="font-bold text-red-700">4</span>
        <div>
          <p class="font-bold text-gray-900">Print your QR signage</p>
          <p class="mt-0.5 text-gray-600">Ready-made posters for your window.</p>
        </div>
      </li>
    </ol>
  </aside>
</div>
